import { Box, Skeleton } from '@mui/material';

import TableSkeleton from '@root/components/table/skeleton';
// import CloudProviderBarSkeleton from '@root/components/v2/content/CloudProviderBar/skeleton';
import ContentBox from '@root/components/v2/content/ContentBox';
import PageContent from '@root/components/v2/layout/PageContent';
export const RiskAnalysisLoader = () => {
  return (
    <Box height={'100%'} width={'100%'} padding={'15px'}>
      {Array.from(new Array(4)).map(item => (
        <Box key={item} display={'flex'} flexDirection={'column'} gap={'15px'} marginBottom={'30px'}>
          <Box display={'flex'} gap={'15px'} alignItems={'center'}>
            <Skeleton variant="circular" height={'45px'} width={'45px'} />
            <Skeleton variant="rectangular" height={'30px'} width={'100%'} />
          </Box>
          <Box display={'flex'} flexDirection={'column'} gap={'10px'}>
            {Array.from(new Array(5)).map(idx => (
              <Skeleton variant="rectangular" height={'24px'} width={'100%'} key={idx} />
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

function UsersSkeleton() {
  return (
    <PageContent>
      {/* <ContentBox paddingMode="content" marginBottom="15px"> */}
      <Box display="flex" flexDirection="row" gap="15px">
        {['Unused Permissions', 'Inactive Users', 'Credential Report', 'Over Privileged Users'].map(title => (
          <ContentBox key={title} title={title} paddingMode="content" style={{ flexGrow: 1, height: '360px' }}>
            <Box
              display="flex"
              flexDirection="column"
              padding={'15px'}
              justifyContent={'space-between'}
              alignItems={'center'}
              height={'320px'}
              // height="352px"
            >
              <Skeleton variant="circular" width="160px" height="160px" />

              <Box flexGrow={1} marginBottom={'0px'} />

              {Array.from(new Array(2)).map((i, index) => (
                <Box key={i} width="100%">
                  <Box
                    display="flex"
                    flexDirection="row"
                    justifyContent="space-between"
                    marginBottom="5px"
                    style={{ opacity: index === 2 ? 0 : 1 }}>
                    <Skeleton width="50%" />
                    <Skeleton width="100px" />
                  </Box>
                </Box>
              ))}
            </Box>
          </ContentBox>
        ))}
      </Box>
      <Box className="Borders RoundedCorners" marginTop={'30px'} marginBottom="15px">
        <Skeleton height="30px" style={{ transform: 'none' }} />
      </Box>

      <Box height={'63.7vh'}>
        <TableSkeleton />
      </Box>
      {/* </ContentBox> */}
    </PageContent>
    // </PageContainer>
  );
}

export default UsersSkeleton;
